export enum AutoRenewNotificationEvent {
  AccountStatusUpdated = 'account-auto-renew-status-updated',
  AssetsStatusUpdated = 'assets-auto-renew-status-updated',
}

export interface AutoRenewNotification {
  eventName: AutoRenewNotificationEvent;
  isEnabled: boolean;
  isSucceeded: boolean;
}
